import actionTypes from 'constants/actionTypes';
import Api from 'services/api';
import apiURLBuilder from 'core/apiURLBuilder';
import { recordEvent, RELIABLE } from 'utilities/uTagging';
import { PROCESS_TYPE_ONBOARDING, TEST_PROCESS_STEP_SUCCESS } from 'utilities/uTagConstants';
import { PATH_DOCUMENTATION_FINISHED } from 'constants/uTagConstants/paths';

const showStandByJointHolders = value => {
    const action = {
        type: actionTypes.SET_STANDBY_JOINT_HOLDERS,
        showStandByJointHolderView: value,
    };

    return action;
};

const getHoldingStatus = () => async (dispatch, getState) => {
    const {
        userProfile: { investmentType, userId, identityMethod, accessToken, clientRisk },
    } = getState();

    const url = apiURLBuilder.getURL('getHoldingStatus');

    const response = await Api.get(url, {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    if (!response?.body?.completedNotified) {
        const { holdingStatus } = response.body;

        const documentationFinishedPath = PATH_DOCUMENTATION_FINISHED;

        recordEvent(
            documentationFinishedPath,
            undefined,
            undefined,
            undefined,
            undefined,
            userId,
            RELIABLE[identityMethod] || '',
            investmentType,
            undefined,
            {
                categoriaEvento: `${PROCESS_TYPE_ONBOARDING} ${TEST_PROCESS_STEP_SUCCESS}`,
                accionEvento: documentationFinishedPath,
                etiquetaEvento: holdingStatus,
                onboardingR: clientRisk || '',
                onboardingIdMethod: RELIABLE[identityMethod],
            }
        );
    }
};

export default {
    showStandByJointHolders,
    getHoldingStatus,
};
